module.exports = __webpack_public_path__ + "img/background.3af7b97a.jpg";